<template>
  <div class="selection-area">
    <div v-for="(pkg, index) in packages" :key="index" :class="{ disabled: !isAllowed() }">
      <div
        @click="select(pkg)"
        class="selection-item"
        :class="{ selected: pkg.id === value, disabled: !isAllowed() }"
      >
        <div class="package">
          <div class="package-header">
            <div class="d-flex align-items-baseline">
              <div class="price">{{ getPrice(pkg) }}</div>
              <div>{{ getFrequency(pkg) }}</div>
            </div>
            <div class="name">{{ getName(pkg) }}</div>
          </div>
          <div class="attributes-section">
            <ul>
              <li>{{ getContainersInfo(pkg) }}</li>
              <li>{{ getAdditionalContainersInfo(pkg) }}</li>
            </ul>
          </div>
          <div class="d-flex justify-content-center">
            <Btn :variant="pkg.id === value ? 'primary' : 'primaryOutline'">
              {{ $t("global.select") }}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import { moneyFormat } from "leatherman-js/utils/formatters/money";

export default {
  name: "FormAdvancedAutoScalePackageSelect",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    packages: {
      type: Array,
      required: true,
    },
    value: Number,
  },
  components: {
    Btn,
  },
  setup(props, { emit, root }) {
    const getAdditionalContainersInfo = (pkg) =>
      root.$t("global.advanced-auto-scale-additional-containers-daily-rate", {
        price: moneyFormat(pkg.pricing.additionalHours * 24),
      });
    const getContainers = (pkg) =>
      root.$t("global.advanced-auto-scale-containers", { containers: pkg.baseQuantity.containers });
    const getContainersInfo = (pkg) => `${getContainers(pkg)} (${getPhpWorkers(pkg)})`;
    const getFrequency = () => "/ mo";
    const getName = (pkg) => pkg.identity;
    const getPhpWorkers = (pkg) =>
      root.$t("global.advanced-auto-scale-php-workers", {
        workers: pkg.baseQuantity.containers * pkg.baseQuantity.workersPerContainer,
      });
    const getPrice = (pkg) => moneyFormat(pkg.pricing.base);

    const isAllowed = () => !props.disabled;

    const select = (pkg) => emit("input", pkg.id);

    return {
      getAdditionalContainersInfo,
      getContainersInfo,
      getFrequency,
      getName,
      getPrice,
      isAllowed,
      select,
    };
  },
};
</script>

<style lang="scss"></style>
